module.exports = __webpack_public_path__ + "img/duty.b4489fe8.png";